import React, { useState, useRef } from 'react';
import './Modifypost.css'
//import { toast } from "react-toastify";
// import './.css';
import axios from 'axios';

function Modifypost() {
  const h2Ref = useRef();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [id, setId] = useState("");

  const submitHandler = (e) => {
    e.preventDefault(); // Fixed typo
    axios.put("https://jsonplaceholder.typicode.com/posts/" + id, [id, title, body]) // Fixed incorrect data format
      .then(() => {
        h2Ref.current.innerHTML = "Success"; // Fixed innerHTML issue
        //toast("success modify");
      })
      .catch(err => console.log(err));
  };

  return (
    <div className='Send'>
      <h2 ref={h2Ref}>Modify post</h2>
      <form onSubmit={submitHandler}>
        <input
          type='text'
          name='id'
          value={id}
          placeholder='Enter id'
          required // Fixed required attribute
          onChange={(e) => setId(e.target.value)}
        />
        <input
          type='text'
          name='title'
          value={title}
          placeholder='Enter title'
          required // Fixed required attribute
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          name='body'
          placeholder='Enter body text'
          required // Fixed required attribute
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
        <button type='submit'>Send Post</button>
      </form>
    </div>
  );
}

export default Modifypost;